var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 228,
    viewBox: "0 0 210 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.291 207.074L147.57 207.074L147.57 186.374L168.291 186.374L168.291 207.074Z",
    fill: "#245864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.01 227.782L168.289 227.782L168.289 207.082L189.01 207.082L189.01 227.782Z",
    fill: "#245864"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.599 227.782L126.879 227.782L126.879 207.082L147.599 207.082L147.599 227.782Z",
    fill: "#FCE784"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7205 186.7L44 186.7L44 166L64.7205 166L64.7205 186.7Z",
    fill: "#FCE784"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7205 227.7L44 227.7L44 207L64.7205 207L64.7205 227.7Z",
    fill: "#FCE784"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.213 20.7002L85.4922 20.7002L85.4922 0L106.213 -9.05722e-07L106.213 20.7002Z",
    fill: "#95C8BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.619 103.542L147.619 82.6641L126.898 82.6641L126.898 103.542",
    fill: "#245864"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.202 144.968L85.5 144.968L85.5 124.268L106.202 124.268L106.202 144.968Z",
    fill: "#245864"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.892 41.4053L106.172 41.4053L106.172 20.7051L126.892 20.7051L126.892 41.4053Z",
    fill: "#245864"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7216 20.7002L65.0195 20.7002L65.0195 0L85.7216 -9.04917e-07L85.7216 20.7002Z",
    fill: "#245864"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7919 61.833L44.0898 61.833L44.0898 41.1328L64.7919 41.1328L64.7919 61.833Z",
    fill: "#245864"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7216 103.903L65.0195 103.903L65.0195 83L85.7216 83L85.7216 103.903Z",
    fill: "#FCE784"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7216 103.903L3.01953 103.903L3.01953 83L23.7216 83L23.7216 103.903Z",
    fill: "#B43125"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7919 145.17L44.0898 145.17L44.0898 124.268L64.7919 124.268L64.7919 145.17Z",
    fill: "#245864"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.721 61.7002L84 61.7002L84 41L104.721 41L104.721 61.7002Z",
    fill: "#B43125"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4951 165.667L64.793 165.667L64.793 144.967L85.4951 144.967L85.4951 165.667Z",
    fill: "#B43125"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5135 207.074L64.793 207.074L64.793 186.374L85.5135 186.374L85.5135 207.074Z",
    fill: "#245864"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7205 165.725L9.05909e-07 165.725L0 145L20.7205 145L20.7205 165.725Z",
    fill: "#203A60"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0888 82.6653L23.3867 82.6653L23.3867 62.1738L44.0888 62.1738L44.0888 82.6653Z",
    fill: "#F5D858"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7021 62.4914L2 62.4914L2 42L22.7021 42L22.7021 62.4914Z",
    fill: "#95C8BF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0888 207.074L23.3867 207.074L23.3867 186.374L44.0888 186.374L44.0888 207.074Z",
    fill: "#B43125"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.902 124.268L147.604 124.268L147.604 144.968L126.902 144.968L126.902 124.268Z",
    fill: "#245864"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M209.721 61.7048L189 61.7048L189 40.8203L209.721 40.8203L209.721 61.7048Z",
    fill: "#245864"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M209.697 207.074L188.977 207.074L188.977 186.374L209.697 186.374L209.697 207.074Z",
    fill: "#245864"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M189.01 186.375L168.289 186.375L168.289 165.755L189.01 165.755L189.01 186.375Z",
    fill: "#245864"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.291 165.667L147.57 165.667L147.57 144.967L168.291 144.967L168.291 165.667Z",
    fill: "#486D97"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M126.924 124.268L106.203 124.268L106.203 103.567L126.924 103.567L126.924 124.268Z",
    fill: "#95C8BF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7205 124.7L44 124.7L44 104L64.7205 104L64.7205 124.7Z",
    fill: "#95C8BF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147.993 20.7002L127.285 20.7002L127.285 0L147.993 -9.05185e-07L147.993 20.7002Z",
    fill: "#228696"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M168.288 144.968L147.586 144.968L147.586 124.268L168.288 124.268L168.288 144.968Z",
    fill: "#B43125"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168.288 124.268L147.586 124.268L147.586 103.567L168.288 103.567L168.288 124.268Z",
    fill: "#FCE784"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M188.991 103.561L168.289 103.561L168.289 82.6768L188.991 82.6768L188.991 103.561Z",
    fill: "#228696"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M209.699 124.268L188.984 124.268L188.984 103.567L209.699 103.567L209.699 124.268Z",
    fill: "#245864"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M209.713 165.667L188.992 165.667L188.992 144.967L209.713 144.967L209.713 165.667Z",
    fill: "#245864"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M209.698 144.968L188.996 144.968L188.996 124.268L209.698 124.268L209.698 144.968Z",
    fill: "#95C8BF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M209.721 82.2077L189 82.2077L189 61.7285L209.721 61.7285L209.721 82.2077Z",
    fill: "#245864"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M147.623 186.375L126.902 186.375L126.902 165.675L147.623 165.675L147.623 186.375Z",
    fill: "#95C8BF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M126.904 207.074L106.184 207.074L106.184 186.374L126.904 186.374L126.904 207.074Z",
    fill: "#245864"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.114 227.782L85.4922 227.782L85.4922 207.082L106.114 207.082L106.114 227.782Z",
    fill: "#203A60"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M126.904 165.667L106.184 165.667L106.184 144.967L126.904 144.967L126.904 165.667Z",
    fill: "#245864"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M168.196 82.6653L147.586 82.6653L147.586 62.1738L168.196 62.1738L168.196 82.6653Z",
    fill: "#245864"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M209.72 20.7002L189.012 20.7002L189.012 0L209.72 -9.05185e-07L209.72 20.7002Z",
    fill: "#245864"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M126.922 41.4053L147.612 41.4053L147.612 62.173L126.922 62.173L126.922 41.4053Z",
    fill: "#B43125"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M147.612 82.6653L126.91 82.6653L126.91 62.1738L147.612 62.1738L147.612 82.6653Z",
    fill: "#F5D858"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M106.203 62.1738L126.924 62.1738L126.924 82.6653L106.203 82.6653L106.203 62.1738Z",
    fill: "#245864"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M106.201 103.549L85.4805 103.549L85.4805 82.6641L106.201 82.6641L106.201 103.549Z",
    fill: "#245864"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M168.289 41.4056L147.574 41.4056L147.574 20.6992L168.289 20.6992L168.289 41.4056Z",
    fill: "#245864"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M188.998 20.7002L168.277 20.7002L168.277 0L188.998 -9.05722e-07L188.998 20.7002Z",
    fill: "#245864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockBg);
export default __webpack_public_path__ + "static/media/block-bg.403f58c54a8200d2b5ee18de3db98159.svg";
export { ForwardRef as ReactComponent };